/* eslint-disable no-redeclare */

/* global require, module */
// Note: A non-compiled version still exists in legacy/media/lib/audiojs/
// and is still used for commenting on legacy pages. Double loads on block pages

// Was downloaded from https://github.com/kolber/audiojs/
const audiojs = require('./audio.js');

audiojs.audiojs.settings.imageLocation = require('./player-graphics.gif');
audiojs.audiojs.settings.swfLocation = require('./audiojs.swf');

// This is meant to be player-graphics@2x.gif, missing from library
audiojs.audiojs.settings.retinaImageLocation = require('./player-graphics.gif');

module.exports = audiojs.audiojs;
